import { BaseNotificationsClient } from "../types/clients";
import {
  FetchReadNotificationIdsParams,
  FetchReadRecordsParams,
  MarkAsReadParams,
  MarkAsReadResponse,
  Notification,
  NotificationReadRecord,
  NotificationsPayload,
  NotificationTypesPayload,
  NotificationTypeItem,
  UnreadCountResponse,
} from "../types/entities";

class NotificationsClient extends BaseNotificationsClient {
  async getNotificationTypes(params?: NotificationTypesPayload): Promise<NotificationTypeItem[]> {
    throw new Error("GET NOTIFICATION TYPES NOT IMPLEMENTED");
  }

  async getNotifications(params?: NotificationsPayload): Promise<Notification[]> {
    throw new Error("GET NOTIFICATIONS NOT IMPLEMENTED");
  }

  async markAsRead(params?: MarkAsReadParams): Promise<MarkAsReadResponse> {
    throw new Error("MARK AS READ NOT IMPLEMENTED");
  }

  async getUnreadCount(): Promise<UnreadCountResponse> {
    throw new Error("GET UNREAD COUNT NOT IMPLEMENTED");
  }

  async fetchReadRecords(params: FetchReadRecordsParams): Promise<NotificationReadRecord[]> {
    throw new Error("FETCH READ RECORDS NOT IMPLEMENTED");
  }

  async fetchReadNotificationIds(params: FetchReadNotificationIdsParams): Promise<number[]> {
    throw new Error("FETCH READ NOTIFICATION IDS NOT IMPLEMENTED");
  }
}

export default NotificationsClient;
